import React, { useState, useEffect } from 'react';
import { setCookie, getCookie } from '../../utils/cookies';

const Cookies = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState({});
  const [isAccepted, setIsAccepted] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie-consent')) {
      setIsVisible(true);
    }
  }, []);

  const toggleDetails = (category) => {
    setShowDetails((prev) => ({ ...prev, [category]: !prev[category] }));
  };

  const handleAccept = () => {
    setCookie('user-consent', 'true', { expires: 365 });
    localStorage.setItem('cookie-consent', 'true');
    setIsAccepted(true);
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'false');
    setIsAccepted(false);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <h3>Centro de Preferencias de Privacidad</h3>
        <p>
          Usamos cookies para mejorar tu experiencia. Puedes elegir aceptarlas o rechazarlas.
        </p>
        <button onClick={handleAccept} style={styles.acceptButton}>Aceptar Cookies</button>
        <button onClick={handleReject} style={styles.rejectButton}>Rechazar Cookies</button>
        <div style={styles.cookieCategories}>
          {cookieCategories.map(({ category, description }) => (
            <div key={category} style={styles.category}>
              <button onClick={() => toggleDetails(category)} style={styles.toggleButton}>
                {showDetails[category] ? '-' : '+'} {category}
              </button>
              {showDetails[category] && <p style={styles.description}>{description}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const cookieCategories = [
  {
    category: 'Cookies Estrictamente Necesarias',
    description:
      'Estas cookies son esenciales para que el sitio web funcione y no se pueden desactivar.',
  },
  {
    category: 'Cookies Funcionales',
    description:
      'Estas cookies permiten que el sitio web ofrezca una mejor funcionalidad y personalización.',
  },
  {
    category: 'Cookies de Rendimiento',
    description:
      'Estas cookies nos permiten contar visitas y fuentes de tráfico para medir y mejorar el rendimiento.',
  },
  {
    category: 'Cookies de Publicidad',
    description:
      'Estas cookies pueden usarse para mostrarte anuncios relevantes basados en tu historial de navegación.',
  },
];

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  popup: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  },
  acceptButton: {
    backgroundColor: '#4CAF50',
    color: '#fff',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    margin: '10px',
  },
  rejectButton: {
    backgroundColor: '#F44336',
    color: '#fff',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    margin: '10px',
  },
  cookieCategories: {
    marginTop: '15px',
    textAlign: 'left',
  },
  category: {
    marginBottom: '10px',
  },
  toggleButton: {
    backgroundColor: '#ddd',
    border: 'none',
    padding: '5px',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
  },
  description: {
    backgroundColor: '#f9f9f9',
    padding: '10px',
    borderRadius: '5px',
    marginTop: '5px',
  },
};

export default Cookies;
